//新增公司账号 
import React, { useState } from 'react';
import { Button, Form, Input, message, Card, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { addCompanyAPI } from '@/apis/company';

const layout = {
    labelCol: {
        span: 6,
        style: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
            textAlign: 'right',
            fontWeight: '500',
            paddingRight: '12px',
        }
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

async function addCompany(company) {
    try {
        const res = await addCompanyAPI(company);
        return res;
    } catch (error) {
        console.error("Error adding company:", error);
    }
}

// const localToUTC = (localDateString) => {
//   // 将当地时间字符串转换为Date对象
//   const localDate = new Date(localDateString);
//   // 格式化UTC日期为字符串
//   const utcDateString = localDate.toISOString().replace('Z', '');
//   return utcDateString
// }

// 移除未使用的 powerToString

const AddCompany = () => {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const [messageApi, contextHolder] = message.useMessage();
    const info = (msg) => {
        messageApi.info(msg);
    };

    // 移除未使用的单选状态

    const onFinish = async (values) => {
        const { companyName } = values
        const company = { companyName }
        setLoading(true)
        try {
            const result = await addCompany(company)
            if (result?.code === 0) {
                info('创建成功!')
                form.resetFields()
            } else {
                info(result?.msg || '创建失败!')
            }
        } catch (error) {
            console.error("Error adding company:", error);
            info('创建失败!')
        } finally {
            setLoading(false)
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Card style={{
            width: '100%',
            minHeight: '100%',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            overflow: 'hidden',
        }}
            title={t('CompanyDisplay.CompanyUploadTitle')}
            styles={{
                body: {
                    padding: '0',
                    height: '100%',
                    overflow: 'auto',
                }
            }}
        >
            <Spin spinning={loading} size="large" />
            <div style={{
                width: '100%',
                padding: '20px',
                maxHeight: 'calc(100vh - 120px)',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
                {contextHolder}
                <Form
                    form={form}
                    {...layout}
                    name="basic"
                    style={{
                        width: '100%',
                        maxWidth: '800px',
                        margin: '0 auto',
                        minWidth: '0',
                        boxSizing: 'border-box',
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    {contextHolder}
                    <Form.Item
                        label={t("CompanyAdditionFormList.CompanyName")}
                        name="companyName"
                        rules={[
                            {
                                required: true,
                                message: 'Please input companyName!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Card>
    )
}

export default AddCompany